<template>
  <section>
    <div class="card">
      <div class="card-content">
        <div class="content">
          <div>
            <span class="title is-5">{{ favouriteGroup.name }}</span>
            <favourite-edit-group :favouriteGroup="favouriteGroup"></favourite-edit-group>
          </div>
          <div class="is-size-7 m-t-sm has-text-grey">
            Дата создания: {{ new Date(favouriteGroup.creation_date) | date }}
            <br />
            Количество объектов: {{ favouriteGroup.favourites.length }}
          </div>
        </div>
      </div>
      <footer class="card-footer">
        <favourite-delete-group :favouriteGroup="favouriteGroup"></favourite-delete-group>
        <router-link
          class="card-footer-item"
          :to="{ name: 'favouritesGroup', params: { id: favouriteGroup.id } }"
          append
          >Открыть</router-link
        >
      </footer>
    </div>
  </section>
</template>

<script>
export default {
  components: {
    FavouriteDeleteGroup: () =>
      import(/* webpackChunkName: "FavouriteDeleteGroup" */ '@/components/user/favourites/FavouriteDeleteGroup'),
    FavouriteEditGroup: () =>
      import(/* webpackChunkName: "FavouriteEditGroup" */ '@/components/user/favourites/FavouriteEditGroup')
  },
  props: {
    favouriteGroup: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.card-footer-item {
  user-select: none;
}
</style>
